import React from "react";
import { Link } from "react-router-dom";
import { QrCode } from "lucide-react";

// CiteQR branding — change name/icon/colors here to rebrand.
export const BRAND = {
  name: "CiteQR",
  tagline: "Connect your audience to the research behind your work.",
};

export function Brand({ className = "", light = false }) {
  return (
    <Link
      to="/"
      data-testid="brand-logo"
      className={`inline-flex items-center gap-2 font-heading font-bold tracking-tight ${className}`}
    >
      <span
        className="inline-flex h-8 w-8 items-center justify-center rounded-md"
        style={{ backgroundColor: light ? "#FFFFFF" : "#0A2540" }}
      >
        <QrCode className="h-5 w-5" style={{ color: light ? "#0A2540" : "#0D9488" }} aria-hidden="true" />
      </span>
      <span style={{ color: light ? "#FFFFFF" : "#0A2540" }}>{BRAND.name}</span>
    </Link>
  );
}
